"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.username.placeholder': '输入用户名',
};
